import {
  GridRowModel,
  GridRowParams,
  GridValueFormatterParams,
} from "@mui/x-data-grid";
import { GridModalFormProps, UseGridReturnType } from "common";
import React, { ReactNode, useState } from "react";

export interface DataCardColumnSettings {
  [key: string]: {
    valueFormatter?: (params: GridValueFormatterParams) => null | string;
    renderCell?: (params: {
      field: string;
      row: GridRowModel;
      value?: any;
    }) => null | JSX.Element;
  };
}

export interface CardSettings {
  header?: {
    titleField?: string;
    icon?: (row: { [key: string]: any }) => undefined | JSX.Element;
    subTitleField?: string;
  };
  body?: (row: GridRowModel) => undefined | JSX.Element;
  groupKey?: string;
  renderGroupHeader?: (groupValue: any, rows: GridRowModel[]) => JSX.Element;
}

export interface DataCardProps extends UseGridReturnType {
  canCreate?: boolean;
  canEdit?: boolean;
  canDelete?: boolean;
  showPagination?: boolean;
  dialogFullWidth?: boolean;
  editUrl?: string;
  headerTitle?: JSX.Element;
  headerItems?: ("search" | "refresh")[];
  columnSettings?: DataCardColumnSettings;
  cardSettings?: CardSettings;
  cardActions?: (params: GridRowParams) => JSX.Element[];
  cardHeaderAction?: (params: GridRowParams) => ReactNode;
  renderModalForm?: (props: GridModalFormProps) => ReactNode;
  renderCreateButton?: (create: () => void) => ReactNode;
  canEditCard?: (params: any) => boolean;
  canDeleteCard?: (params: any) => boolean;
}

export default function useDataCard(props: DataCardProps) {
  const [openDialog, setOpenDialog] = useState(false);
  const [itemId, setItemId] = useState("create");

  const getValue = (
    row: GridRowModel,
    field: string,
    valueFormatter?: (params: GridValueFormatterParams) => any
  ) => {
    if (!row[field]) {
      return "";
    }

    const columnSetting = props.columnSettings
      ? props.columnSettings[field]
      : undefined;
    const renderCell = columnSetting?.renderCell;
    const formatter = valueFormatter ?? columnSetting?.valueFormatter;

    if (renderCell) {
      return renderCell({
        field: field,
        value: row[field],
        row: row,
      });
    }

    if (formatter) {
      return formatter({
        field: field,
        value: row[field],
        api: null,
      });
    }

    if (row[field] instanceof Object) {
      return "Object";
    }

    return row[field];
  };

  const onPageChange = (
    event: null | React.MouseEvent<HTMLButtonElement>,
    page: number
  ): void => {
    props.onPageChange(page);
  };

  const onPageSizeChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    props.onPageSizeChange(parseInt(event.target.value, 10));
  };

  const ShowDialog = (id?: string) => {
    setOpenDialog(true);
    setItemId(id ?? "create");
  };

  const CloseDialog = () => {
    setOpenDialog(false);
    setItemId("create");
  };

  return {
    openDialog,
    itemId,
    ShowDialog,
    CloseDialog,
    getValue,
    onPageChange,
    onPageSizeChange,
  };
}
